import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    NavLink, 
    } from "reactstrap";

class DashMenuItem extends Component {
    constructor(props) {
        super(props);
      
    }
    render() {
        return (
            <>
            <Link to={this.props.link}>
                <div  onClick={this.props.action}>
                <div className="dash__menu__item d-flex flex-column align-items-center">
                    <img className="dash__icons" src={this.props.icon} alt="" style={{width: this.props.size, height: this.props.size,transform : [this.props.rotate] }}/>
                    <h6 className="dash__menu__txt text-center">{this.props.txt}</h6>
                </div>
                </div>
            </Link>
            </>
        );
    }
}

export default DashMenuItem;